function importAll(r) {
    console.log(r.keys());
    r.keys().forEach(r);
  }
  
  window.$ = $;
  window.jQuery = $;
  import "jquery.scrollto";
  import Rails from "@rails/ujs";
  Rails.start();
  
  import "slick-carousel";
  import "slick-carousel/slick/slick.css";
  import "jquery-colorbox";
  
  importAll(require.context("hoch2023ru/images", true));
  import "normalize.css";
  import "hoch2023ru/styles/hoch2023ru.sass";
  import 'scrolldepth/jquery.scrolldepth.min.js'